import { Share2, Sliders, Download } from 'lucide-react'
import './LandingHowItWorks.css'

const steps = [
  {
    number: '1',
    Icon: Share2,
    title: 'Chat exportieren',
    desc: 'WhatsApp öffnen → Chat auswählen → Mehr → Chat exportieren → Als ZIP speichern.',
  },
  {
    number: '2',
    Icon: Sliders,
    title: 'Vorschau anpassen',
    desc: 'ZIP hochladen. Farben, Layout und Filter nach deinem Geschmack einstellen — kostenlos.',
  },
  {
    number: '3',
    Icon: Download,
    title: 'PDF herunterladen',
    desc: 'Kostenlos mit Wasserzeichen herunterladen — oder einmalig €4,99 für das vollständige PDF ohne Wasserzeichen.',
  },
]

export function LandingHowItWorks() {
  return (
    <section id="so-funktioniert" className="how-it-works">
      <div className="hiw-inner">
        <div className="hiw-header">
          <h2 className="hiw-title">So funktioniert's</h2>
          <p className="hiw-subtitle">In 3 Schritten zum PDF — ohne Anmeldung</p>
        </div>
        <div className="hiw-steps">
          {steps.map(({ number, Icon, title, desc }) => (
            <div key={number} className="hiw-step">
              <div className="hiw-step-header">
                <div className="hiw-step-number">{number}</div>
                <div className="hiw-step-icon">
                  <Icon size={20} />
                </div>
              </div>
              <h3 className="hiw-step-title">{title}</h3>
              <p className="hiw-step-desc">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
